module.exports = __webpack_public_path__ + "img/newInt-rs-f2f.acc52c92.svg";